import { getAgencyPVQOptions } from 'constants/enums/legalOptions';

const pvqInvestigatingAgency = {
  value: {
    presence: true,
    inclusion: getAgencyPVQOptions().map((item) => item.value),
  },
};

export default pvqInvestigatingAgency;
